//Add new row on the table "Rating Settings"
//to create a new element
(function () {
	document.addEventListener("DOMContentLoaded", function () {
		var buttons = document.getElementsByClassName("addRating");

		if (buttons.length !== 0) {
			for (let i = 0; i < buttons.length; i++) {
				buttons[i].addEventListener("click", function (event) {
					event = event || window.event;

					var button = this;
					var num = button.dataset.num;
					var key = button.dataset.key;

					var tbody = document.getElementById(key + "-" + num).nextElementSibling;

					var localNumber = num * 1000 + tbody.children.length;

					//create row
					var row = document.createElement("tr");
					var td1 = document.createElement("td");
					var td2 = document.createElement("td");
					var td3 = document.createElement("td");

					td1.setAttribute("colspan", 2);

					var inputName   = document.createElement("input");
					var inputHidden = document.createElement("input");
					var inputPoints = document.createElement("input");

					inputName.type = "text";
					inputName.name = `items[${localNumber}][name]`;
					inputName.placeholder = "Field text";

					inputHidden.type  = "hidden";
					inputHidden.name  = `items[${localNumber}][input_name]`;
					inputHidden.value = `${key}`;

					inputPoints.type = "text";
					inputPoints.name = `items[${localNumber}][points]`;
					inputPoints.placeholder = "Field Points";
					inputPoints.value = 0;

					row.appendChild(td1); // <-- inputName && inputHidden
					row.appendChild(td2); // <-- inputPoints
					row.appendChild(td3); // <-- empty

					td1.appendChild(inputName);
					td1.appendChild(inputHidden);
					td2.appendChild(inputPoints);

					//add row in the tbody
					tbody.insertBefore(row, tbody.firstChild);
				});
			}
		}
	});
})();

